module.exports = __webpack_public_path__ + "static/media/1.2254f9c6.jpg";